import { TableCell, TableRow } from "@mui/material";

export const TransferBreakdownTableHeaderRow = ({name, bgcolor}) => {
  return (
    <TableRow>
      <TableCell sx={{fontWeight: 'bold', bgcolor, padding: 1, fontSize: 15}}>{name}</TableCell>
      <TableCell sx={{bgcolor}}/>
    </TableRow>
  )
}

export const TransferBreakdownTableAmountRow = ({name, amount}) => {
  return (
    <TableRow>
      <TransferBreakdownTableNameCell name={name} />
      <TransferBreakdownTableAmountCell amount={amount} />
    </TableRow>
  );
}

const TransferBreakdownTableNameCell = ({name}) => (
  <TableCell sx={{padding: 1, width: 200, fontSize: 15}}>
    {name}
  </TableCell>
);

const TransferBreakdownTableAmountCell = ({amount, ...props}) => (
  <TableCell align={amount != null ? "right" : "center"} sx={{padding: 1, width: 100, fontSize: 15}} {...props}>
    {amount != null ? amount.toLocaleString() : "-"}
  </TableCell>
);
